var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.31434 8.50426L6.06621 12.0222C6.42122 12.0222 6.57498 11.8684 6.75936 11.6838L8.42377 10.0805L11.8726 12.6263C12.5051 12.9816 12.9508 12.7945 13.1214 12.0398L15.3852 1.34749L15.3858 1.34686C15.5864 0.404387 15.0477 0.0358385 14.4314 0.267047L1.12484 5.40215C0.216698 5.75747 0.230448 6.26777 0.970466 6.49898L4.37242 7.56556L12.2745 2.58166C12.6464 2.33344 12.9845 2.47078 12.7064 2.71899L6.31434 8.50426Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.08f560ab5a114fdc4497ae76d3ce51b7.svg";
export { ForwardRef as ReactComponent };